import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate, useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import ai_powered_cv_logo from "../../../assets/img/Ai-powered-cv-logo.png";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Spinner,
} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import "./ResetPassword.css";
import { Link } from "react-router-dom";
const BASE_URL = process.env.REACT_APP_BASE_URL;

// Validation Schema
const validationSchema = Yup.object({
  newPassword: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .required("Password is required"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
    .required("Confirm Password is required"),
});

function ResetPassword() {
  const navigate = useNavigate();
  const location = useLocation();
  const [token, setToken] = useState(null);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const tokenFromUrl = queryParams.get("token");
    setToken(tokenFromUrl);
  }, [location]);

  const formik = useFormik({
    initialValues: { newPassword: "", confirmPassword: "" },
    validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      if (!token) {
        toast.error("Invalid or expired token.");
        return;
      }
      setSubmitting(true);
      try {
        await axios.post(
          `${BASE_URL}/api/users/reset-password?token=${token}`,
          values
        );
        toast.success("Password reset successfully!");
        setTimeout(() => navigate("/login"), 1500);
      } catch (error) {
        if (error.response?.status === 400)
          toast.error("Invalid or expired token.");
        else if (error.response?.status === 500)
          toast.error("Server is down. Try again later.");
        else toast.error("Something went wrong.");
      } finally {
        setSubmitting(false);
      }
    },
  });

  if (!token) {
    return (
      <div className="reset-password-container text-center">
        <h2 className="text-danger">Invalid or expired reset link.</h2>
      </div>
    );
  }

  return (
    <div className="reset-password-container">
      <Container className="d-flex flex-column align-items-center justify-content-center ">
        <h1 className="text-white fw-bold mb-4">
        
                   <Link to="/" className="text-decoration-none d-flex justify-content-center me-3 ">
                     <img 
                       src={ ai_powered_cv_logo}
                       alt="AI-Powered CV" 
                       className="logo-img w-50"
                     />
                   </Link>
        </h1>

        <Row className="justify-content-center w-100">
          <Col md={6} lg={5}>
            <Card className="p-4 glassmorphism">
              <Card.Body>
                <h2 className="text-center mb-4 text-white">
                  Reset Your Password
                </h2>
                <p className="text-center text-white">
                  Enter a new password for your account.
                </p>
                <Form onSubmit={formik.handleSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Control
                      type="password"
                      name="newPassword"
                      placeholder="New Password"
                      {...formik.getFieldProps("newPassword")}
                      isInvalid={
                        formik.touched.newPassword && formik.errors.newPassword
                      }
                      className="p-2"
                    />
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.newPassword}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Control
                      type="password"
                      name="confirmPassword"
                      placeholder="Confirm Password"
                      {...formik.getFieldProps("confirmPassword")}
                      isInvalid={
                        formik.touched.confirmPassword &&
                        formik.errors.confirmPassword
                      }
                      className="p-2"
                    />
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.confirmPassword}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Button
                    type="submit"
                    className="w-100 btn-custom"
                    disabled={formik.isSubmitting}
                  >
                    {formik.isSubmitting ? (
                      <Spinner animation="border" size="sm" />
                    ) : (
                      "Reset Password"
                    )}
                  </Button>

                  <div className="text-center mt-3">
                    <Link to="/login" className="text-white">
                      Back to Login
                    </Link>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      <ToastContainer />
    </div>
  );
}

export default ResetPassword;
